<div class="fd" [class.fd--open]="open">
    <button type="button" class="fd__trigger" [attr.aria-expanded]="open" aria-haspopup="listbox" (click)="toggle($event)">
        <span class="fd__label" [title]="selectedLabel">{{ selectedLabel }}</span>
        <i class="bi bi-chevron-down fd__chevron"></i>
    </button>

    <div class="fd__panel" *ngIf="open" (click)="$event.stopPropagation()">
        <div class="fd__search">
            <i class="bi bi-search"></i>
            <input #searchInput type="text" class="form-control" [placeholder]="searchPlaceholder"
                [ngModel]="query" (ngModelChange)="query = $event" />
        </div>
        <ul class="fd__list" role="listbox">
            <li *ngFor="let option of filteredOptions; trackBy: trackByValue" class="fd__option" role="option"
                [class.fd__option--selected]="(option.value || '') === (value || '')"
                [attr.aria-selected]="(option.value || '') === (value || '')" (click)="select(option)">
                <span class="fd__option-label" [title]="option.label">{{ option.label || 'Unknown' }}</span>
                <span class="fd__count" *ngIf="option.count !== undefined && option.count !== null">{{ option.count }}</span>
            </li>
            <li class="fd__empty" *ngIf="!filteredOptions.length">{{ emptyText }}</li>
        </ul>
    </div>
</div>
